<template>
    <div class="versionWrap">
        <div class="searchBox">
            <el-button @click="openAdd" type="primary" v-if="functionAddVersion">新增版本</el-button>
        </div>
        <div class="tableBox">
            <el-table v-loading="isLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)" border stripe :data="tableData"
                tooltip-effect="dark" style="width: 100%">
               <!-- <el-table-column type="selection" width="55">
                </el-table-column> -->
                <!-- <el-table-column label="序号" >
                    <template slot-scope="scope">{{ total-((searchObj.page-1)*searchObj.num+ scope.$index) }}</template>
                </el-table-column> -->
                <el-table-column label="ID" width="50">
                    <template slot-scope="scope">{{ scope.row.version_id }}</template>
                </el-table-column>
                <el-table-column label="版本号">
                    <template slot-scope="scope">{{ scope.row.version }}</template>
                </el-table-column>
                <el-table-column label="平台类型"  width="80">
                    <template slot-scope="scope">{{ scope.row.platform }}</template>
                </el-table-column>
                <el-table-column label="下载链接" width="200">
                    <template slot-scope="scope">{{ scope.row.download_url }}</template>
                </el-table-column>
                <el-table-column label="升级方式">
                    <template slot-scope="scope">
                        <span>{{ scope.row.update_type | turnValToText("update_type")}}</span>
                    </template>
                </el-table-column>
                 <el-table-column label="描述">
                    <template slot-scope="scope">{{ scope.row.description }}</template>
                </el-table-column>
                <el-table-column label="操作时间">
                   <template slot-scope="scope">{{ scope.row.initial_time }}</template>
                </el-table-column>
                <el-table-column label="操作" width="90" >
                    <template slot-scope="scope">
                        <div style="text-align: center;">
                            <el-button type="success" size="mini"  @click="openEditModal(scope.row)" v-if="functionEditVersion">修改</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="searchObj.page"
                :page-size.sync="searchObj.num" layout="total, sizes, prev, pager, next, jumper" :total="total"
                background>
            </el-pagination>
        </div>
        <el-dialog :title="modalTitle" :visible.sync="isShowModal"  :center="true" width="400px">
            <div v-loading="isLoadingModal" class="modalFormWrap">
                <div v-if="formArg.versionId" style="padding:0 50px;color:blue"> ID： {{formArg.versionId}}</div>
                
                <el-form :model="formArg" :rules="rules" ref="form" label-width="100px" class="demo-ruleForm">
                  <el-form-item label="版本号" prop="version" required>
                    <el-input v-model="formArg.version" ></el-input>
                  </el-form-item>
                  <el-form-item label="平台类型" prop="platform" required>
                    <el-select v-model="formArg.platform" placeholder="请选择类型">
                      <el-option label="android" value="android"></el-option>
                      <el-option label="ios" value="ios"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="升级方式" prop="updateType" required>
                    <el-select v-model="formArg.updateType" placeholder="请选择类型">
                      <el-option :label="list_updateType.text" :value="list_updateType.value" :key="index_updateType" v-for="(list_updateType,index_updateType) in updateTypeOptions"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="描述" prop="description" required>
                    <el-input type="textarea" v-model="formArg.description"></el-input>
                  </el-form-item>
                  <el-form-item label="下载链接" prop="downloadUrl" required>
                    <el-input v-model="formArg.downloadUrl"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="clickModalSubmit('form')">{{modalTitle}}</el-button>
                  </el-form-item>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {        json,        wordData    } from '@/common/common.js'
    import {        ajaxPost    } from '@/common/request.js'
    import authmodal from '@/components/authModal.vue'
    import {        utils    } from '@/common/common.js'
    export default {
        name: 'adminIndex',
        data() {
            return {
                isLoading: false,
                isLoadingModal:false,
                searchObj: {
                    page: 1,
                    num: 10,
                },
                //表格
                tableData: [],
                //分页
                total: 0,
                modalTitle:'',
                modalType:'',
                isShowModal: false,//新增和编辑用的都是这个
                formArg:{
                    version:'',
                    description:'',
                    platform:'',
                    downloadUrl:'',
                    updateType:'',
                    versionId:'',
                },
                rules:{},

            }
        },
        computed: {
            functionAddVersion(){
                return utils.getCurrentFunction().indexOf("addVersion")>-1
            },
            
            functionEditVersion(){
                return utils.getCurrentFunction().indexOf("editVersion")>-1
            },
            
            updateTypeOptions() {
                return wordData.update_type
            },
            adminId() {
                let oUserInfo=utils.getItem('userInfo')?JSON.parse(utils.getItem('userInfo')) :{}
                console.log(oUserInfo.adminId,'computed里的adminId')
                return oUserInfo.adminId
            },
            
        },
        methods: {
            clickModalSubmit(formName) {
                let _this=this
                this.$refs[formName].validate((valid) => {
                  if (valid) {
                    _this.isLoadingModal = true
                    if(_this.modalType=='add'){
                      ajaxPost('/admin/addAppVersion', _this.formArg).then(function(res) {
                          if(res.errorCode==200){
                              _this.$message({
                                  message: "添加成功",
                                  type: 'success',
                                  duration: 1000
                              });
                              
                              _this.resetForm(formName)
                              _this.isShowModal=false
                              _this.handleCurrentChange(1)
                          }else{
                              alert(res.errorMsg)
                          }
                          _this.isLoadingModal = false
                      }, function(res) {
                          _this.isLoadingModal = false
                      })  
                    }else if(_this.modalType=='edit'){
                        ajaxPost('/admin/updateAppVersion', _this.formArg).then(function(res) {
                            if(res.errorCode==200){
                                _this.$message({
                                    message: "修改成功",
                                    type: 'success',
                                    duration: 1000
                                });
                                
                                _this.resetForm(formName)
                                _this.isShowModal=false
                                _this.getTableLists()
                            }else{
                                alert(res.errorMsg)
                            }
                            _this.isLoadingModal = false
                        }, function(res) {
                            _this.isLoadingModal = false
                        }) 
                    }
                    
                  } else {
                    console.log('error submit!!');
                    return false;
                  }
                });
                
                
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            emptyValid(formName){
                if (this.$refs[formName]!==undefined) {
                     this.$refs[formName].clearValidate(); 
                }
                
            },
            back() {
                this.$router.back()
            },
            openAdd(){
               
               
               this.modalType='add'
               this.modalTitle="新增版本"
               this.isShowModal=true
               this.formArg={
                   version:'',
                   description:'',
                   platform:'',
                   downloadUrl:'',
                   updateType:'',
                   versionId:'',
               }
               // this.resetForm('form')
               this.emptyValid('form')
            },
            openEditModal(list){
                
                this.modalType='edit'
                this.modalTitle="编辑版本"
                this.isShowModal=true
                // this.resetForm('form')

                this.formArg.version=list.version
                this.formArg.versionId=list.version_id
                this.formArg.description=list.description
                this.formArg.platform=list.platform
                this.formArg.downloadUrl=list.download_url
                this.formArg.updateType=list.update_type
            },
            getTableLists() {
                let _this = this
                this.isLoading = true
                ajaxPost('/admin/appVersionList', this.searchObj).then(function(res) {
                    _this.tableData = []
                    _this.isLoading = false
                    if (res.data && res.data.appVersionList) {
                        _this.total = res.data.totalCount
                        res.data.appVersionList.forEach(function(item, index) {
                            let buffer = {}
                            //id,名字，手机号，注册时间，渠道，身份，状态，地址
                            buffer.description = item.description
                            buffer.download_url = item.download_url
                            buffer.initial_time = item.initial_time
                            buffer.platform = item.platform
                            buffer.update_type = item.update_type
                            buffer.version = item.version
                            buffer.version_id = item.version_id
                            _this.tableData.push(buffer)

                        })

                    }
                }, function(res) {
                    _this.isLoading = false
                })
            },
            handleSizeChange(size) { //分页：每页n条
                this.searchObj.num = size
                this.searchObj.page = 1
                this.getTableLists()
            },
            handleCurrentChange(page) { //分页：改变第n页
                this.searchObj.page = page
                this.getTableLists()
            },
        },
        created() {
        
        },
        mounted(){
            console.log("执行mounted")
            this.getTableLists()
        }
    }
</script>

<style scoped lang="scss">
    .versionWrap{
        .searchBox{
            padding:10px 30px;
        }
        .tableBox{
            padding:0px 30px;
        }
    }
    .modalFormWrap .el-input,.modalFormWrap .el-textarea{
        width: 217px;
    }
    
</style>



// WEBPACK FOOTER //
// src/pages/version/index.vue